import commonPageService from 'pcCommon/services/commonPageService';
import video from 'globalCommon/utils/video';
import { syncRender } from 'globalCommon/services/syncRender';
import './reset.css';
import './style.css';

const init = () => {
    commonPageService({ renderAfter: syncRender });
    video.init();
};

init();
